/**
 * This element specifies that a preset line dashing scheme should be used.
 *
 * It's a list of comma and/or white space separated <length>s and <percentage>s
 * that specify the lengths of alternating dashes and gaps.
 *
 * REF: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-dasharray
 */
export enum DashPresets {
    DASH = "DASH",				                // 6
    DOT = "DOT", 				                // 3,6
    LARGE_DASH = "LARGE_DASH",			        // 18,9
    LARGE_DASH_DOT = "LARGE_DASH_DOT",		    // 18,6,6,6
    MEDIUM_DASH = "MEDIUM_DASH",                // 12,6
    SMALL_DOT = "SMALL_DOT",                    // 3
    SOLID = "SOLID", 			                // none
}
